var map = {
	"./Clicktogo.jpeg": 8070,
	"./airve.png": 9403,
	"./dilmah.png": 7917,
	"./enovaivetravels.png": 7706,
	"./epicdestino.png": 1061,
	"./flexigotrip.png": 1417,
	"./globaltripyatra.png": 4197,
	"./goflights.png": 5451,
	"./holidigo.png": 7871,
	"./lsvacations.png": 5197,
	"./mindgo.png": 7972,
	"./pay4yatra.jpg": 375,
	"./travelsolutionsredefined.jpeg": 3473,
	"./tritrip.png": 7930,
	"./voyagerisers.png": 1707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2434;